import Vue from 'vue';
import Router from 'vue-router';
import ls from '../services/ls';
import getCookie from '../utils/getCookie';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/pdd/tickets',
    },
    {
      path: '/pdd/tickets',
      name: 'tickets',
      component: () => import('../views/tests/Tickets.vue'),
      meta: {
        title: 'Билеты',
      },
    },
    {
      path: '/pdd/tickets/:id',
      name: 'ticket',
      component: () => import('../views/tests/TicketQuestions.vue'),
      meta: {
        title: 'Вопросы',
      },
    },
    {
      path: '/pdd/exams',
      name: 'exams',
      component: () => import('../views/tests/Exams.vue'),
      meta: {
        title: 'Экзамены',
      },
    },
    {
      path: '/pdd/exams/:id',
      name: 'exam',
      component: () => import('../views/tests/ExamQuestions.vue'),
      meta: {
        title: 'Вопросы экзамена',
      },
    },
    {
      path: '/pdd/exams/constructors/:id',
      name: 'constructor',
      component: () => import('../views/tests/ConstructorQuestions.vue'),
      meta: {
        title: 'Вопросы экзамена',
      },
    },
    {
      path: '/pdd/themes',
      name: 'themes',
      component: () => import('../views/tests/Themes.vue'),
      meta: {
        title: 'Вопросы по темам',
      },
    },
    {
      path: '/pdd/themes/:id',
      name: 'theme',
      component: () => import('../views/tests/ThemeQuestions.vue'),
      meta: {
        title: 'Вопросы',
      },
    },
    {
      path: '/pdd/marathon',
      name: 'marathon',
      component: () => import('../views/tests/Marathon.vue'),
      meta: {
        title: 'Марафон ПДД',
      },
    },
    {
      path: '/pdd/marathon/:uuid/training',
      name: 'marathon-training',
      component: () => import('../views/tests/MarathonTraining.vue'),
      meta: {
        title: 'Тренировка по ошибкам',
      },
    },
    {
      path: '/pdd/marathon/:uuid/themes',
      name: 'marathon-themes',
      component: () => import('../views/tests/MarathonThemes.vue'),
      meta: {
        title: 'Темы с ошибками',
      },
    },
    {
      path: '/pdd/marathon/:uuid',
      name: 'marathon-session',
      component: () => import('../views/tests/MarathonSession.vue'),
      meta: {
        title: 'Марафон ПДД',
      },
    },
    {
      path: '/pdd/results/:uuid',
      name: 'result',
      component: () => import('../views/tests/Result.vue'),
      meta: {
        title: 'Результат тестирования',
      },
    },
    {
      path: '/pdd/cathid',
      name: 'cathid',
      meta: {
        title: 'Сath',
      },
      beforeEnter: (to, from, next) => {
        if (to.query.key) {
          let cathid = null;
          let cookieCatchId = getCookie('cathid');

          if (cookieCatchId) {
            cookieCatchId = JSON.parse(cookieCatchId);

            if (!cookieCatchId.includes(to.query.key)) {
              cookieCatchId.push(to.query.key);

              cathid = JSON.stringify(cookieCatchId);
            }
          } else {
            cathid = JSON.stringify([to.query.key]);
          }

          if (cathid) {
            document.cookie = `cathid=${cathid}; max-age=7776000`;
          }

          next({ name: 'tickets', params: { cathKey: to.query.key } });
        } else {
          next({ name: 'tickets' });
        }
      },
    },
    {
      path: '/pdd/consid',
      name: 'consid',
      meta: {
        title: 'Cons',
      },
      beforeEnter: (to, from, next) => {
        if (to.query.key) {
          let consid = null;
          let cookieConsId = getCookie('consid');

          if (cookieConsId) {
            cookieConsId = JSON.parse(cookieConsId);

            if (!cookieConsId.includes(to.query.key)) {
              cookieConsId.push(to.query.key);

              consid = JSON.stringify(cookieConsId);
            }
          } else {
            consid = JSON.stringify([to.query.key]);
          }

          if (consid) {
            document.cookie = `consid=${consid}; max-age=7776000`;
          }
        }

        next({ name: 'exams' });
      },
    },
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  ls.set('pdd-settings', JSON.stringify(Vue.prototype.$appSettings));

  next();
});

router.afterEach(() => {
  Vue.prototype.$appSettings = JSON.parse(ls.get('pdd-settings'));
});

export default router;
